// extracted by mini-css-extract-plugin
module.exports = {"map":"BldgInfoBlob_map__F-vfj","wrapper":"BldgInfoBlob_wrapper__4aJED","frame-blob":"BldgInfoBlob_frame-blob__1_R6W","text":"BldgInfoBlob_text__JkdtG"};